var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Widget, EditableWidget, LayoutWidget, LayoutWidgetHeader } from "../";

import AppsWidgetList from './AppsWidgetList';
import AppsWidgetEdit from './AppsWidgetEdit';

import "./AppsWidget.scss";

var AppsWidget = (_temp2 = _class = function (_Component) {
    _inherits(AppsWidget, _Component);

    function AppsWidget() {
        var _temp, _this, _ret;

        _classCallCheck(this, AppsWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getWidget = function () {
            var apps = _this.props.apps;


            return _extends({}, _this.props, {
                uiSchema: undefined,
                formData: {
                    apps: apps
                }
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AppsWidget.prototype.render = function render() {
        var widget = this.getWidget();

        return React.createElement(
            Widget,
            widget,
            React.createElement(AppsWidgetList, widget)
        );

        return React.createElement(
            EditableWidget,
            _extends({}, widget, { widgetTemplate: AppsWidgetList, widgetEditor: AppsWidgetEdit }),
            React.createElement(AppsWidgetList, widget)
        );
    };

    return AppsWidget;
}(Component), _class.defaultProps = {
    expanded: true,
    widgetType: "apps",
    widgetSize: "16:2",
    icon: "apps",
    title: "Snarveier",
    description: "Snarveier til applikasjoner",
    apps: [],
    schema: {
        type: "object",
        properties: {
            widgetType: {
                type: "string",
                default: "apps"
            },
            widgetSize: {
                type: "string",
                pattern: "grid",
                enum: ["1:1", "2:1", "1:2", "4:1"]
            },
            apps: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        appId: {
                            type: "string"
                        },
                        title: {
                            type: "string"
                        },
                        url: {
                            type: "string"
                        }
                    }
                }
            }
        }
    }
}, _temp2);


export default AppsWidget;